import {
  ELECTRIC_SCOOTER_INTRO_STEP,
  ELECTRIC_SCOOTER_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/ElectricScooter";

import { BooleanFormType } from "Store/interfaces/FormTypes";
import { ElectricScooterCoverage } from "Store/interfaces/products/coverage";
import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";
import { mapInjuriesToForm } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { isUndefined } from "Utils/functions";

export const mapFromCommerceElectricScooter = (
  data: Record<string, any>,
): FormState => {
  return {
    [ELECTRIC_SCOOTER_INTRO_STEP.id]: {
      topSpeed: BooleanFormType.TRUE,
      modelYear: String(data.modelYear),
      brand: data.brand,
      model: data.model,
      ...mapInjuriesToForm(data.damageCountRecentYears, data.yearOfLastDamage),
    },
    [ELECTRIC_SCOOTER_PRICE_STEP.id]: {
      coverage: isUndefined(data.coverageGroup)
        ? ElectricScooterCoverage.ELECTRIC_SCOOTER_FULL_OWN_DAMAGE
        : data.coverageGroup,
    },
  };
};
